(() => {
  const rootSelector = '[data-pawtato-style-picker]';

  function loadGridImages(details) {
    details.querySelectorAll('img[data-src]').forEach((image) => {
      if (!image.getAttribute('src')) image.src = image.dataset.src;
    });
  }

  function updateOption(root, optionName, value) {
    const productInfo = root.closest('product-info') || document;
    const select = productInfo.querySelector(`select[name="options[${optionName}]"]`);
    if (!select) return;

    const choice = root.querySelector(
      `[data-option-name="${optionName}"][data-option-value="${value}"]`
    );
    const preview = root.querySelector(`[data-selected-preview="${optionName}"]`);
    const code = root.querySelector(`[data-selected-code="${optionName}"]`);

    root.querySelectorAll(`[data-option-name="${optionName}"]`).forEach((button) => {
      const selected = button.dataset.optionValue === value;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    if (choice && preview) {
      preview.src = choice.dataset.previewSrc;
      preview.alt = `Selected ${optionName.toLowerCase()} ${value}`;
    }
    if (code) code.textContent = value;
  }

  function initialize(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const productInfo = root.closest('product-info') || document;
    ['Phone Strap Style', 'Pet Charm Style'].forEach((optionName) => {
      const select = productInfo.querySelector(`select[name="options[${optionName}]"]`);
      if (!select) return;
      updateOption(root, optionName, select.value);
      select.addEventListener('change', () => updateOption(root, optionName, select.value));
    });

    root.querySelectorAll('[data-style-details]').forEach((details) => {
      details.addEventListener('toggle', () => {
        if (details.open) loadGridImages(details);
      });
    });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-option-name][data-option-value]');
    if (!button) return;
    const root = button.closest(rootSelector);
    const productInfo = root.closest('product-info') || document;
    const optionName = button.dataset.optionName;
    const select = productInfo.querySelector(`select[name="options[${optionName}]"]`);
    if (!select) return;

    select.value = button.dataset.optionValue;
    select.dispatchEvent(new Event('change', { bubbles: true }));
    updateOption(root, optionName, select.value);
    button.closest('details').open = false;
  });

  const observer = new MutationObserver(() => {
    document.querySelectorAll(rootSelector).forEach(initialize);
  });

  document.querySelectorAll(rootSelector).forEach(initialize);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
